export default __webpack_public_path__ + "static/media/Bus.4e109a38.png";